import { FormikErrors, getIn } from "formik";

function isFieldInErrors(
  props: string[],
  errors: Record<string, any>
): boolean {
  const prop = props.shift();
  if (!prop) {
    return Boolean(errors);
  }
  if (prop.endsWith("[]")) {
    // eslint-disable-next-line no-magic-numbers
    const errorKey = prop.slice(0, -2);
    if (errors[errorKey]) {
      return errors[errorKey].some((item: any) =>
        isFieldInErrors(props.slice(), item)
      );
    }
    return false;
  }
  const error = (errors && errors[prop]) || false;
  return isFieldInErrors(props.slice(), error);
}

export function isTabInvalid(fields: string[], errors: FormikErrors<unknown>) {
  return fields.some((field) => {
    /*
     * This is for backwards compatibility. Please use arrayField[index] instead
     * of arrayField[].
     */
    if (field.includes("[]") && isFieldInErrors(field.split("."), errors)) {
      return true;
    }
    return getIn(errors, field) !== undefined;
  });
}
